import { useEffect } from "react";

/**
 * Make Escape close only a popover that sits inside a Dialog.
 *
 * The app's Dialog and Popover ship different copies of Radix's layer stack
 * (@radix-ui/react-dismissable-layer), so each thinks it is the topmost layer
 * and one Escape closes both. Radix listens on `document` in capture phase,
 * so the only earlier hook is a capture listener on `window`.
 */
export function useEscapeClosesPopoverInDialog(open: boolean, close: () => void) {
  useEffect(() => {
    if (!open) return;
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      event.stopPropagation();
      event.preventDefault();
      close();
    };
    window.addEventListener("keydown", handleEscape, true);
    return () => window.removeEventListener("keydown", handleEscape, true);
  }, [open, close]);
}
